import { Button, Container } from '@mui/material';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import Elements from '../../../Elements';

export default function Subscription({ classes }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <div className="center">
          <img src={Images.Logo} alt="box pack" className="mt-5" />
          <h4 className="mt-5">{t('subs.welcome')}</h4>
          <div className="s-16 mt-3">{t('subs.tagline')}</div>
        </div>

        <Container className="mt-6">
          <div className="flex gap-12 align-items-center mt-3 benefit-card">
            <img height="42" src={Images.OenoStorage} alt="safety" />
            <div>
              <div className="weight-700">{t('subs.feat1')}</div>
              <div className="mt-1 height-14">{t('subs.desc1')}</div>
            </div>
          </div>
          <div className="flex gap-12 align-items-center mt-3 benefit-card">
            <img height="42" src={Images.OenoMarket} alt="safety" />
            <div>
              <div className="weight-700">{t('subs.feat2')}</div>
              <div className="mt-1 height-14">{t('subs.desc2')}</div>
            </div>
          </div>
          <div className="flex gap-12 align-items-center mt-3 benefit-card">
            <img height="42" src={Images.OenoGuarantee} alt="safety" />
            <div>
              <div className="weight-700">{t('subs.feat3')}</div>
              <div className="mt-1 height-14">{t('subs.desc3')}</div>
            </div>
          </div>
        </Container>

        <div className="floating-action">
          <Container>
            <Button className="btn-contained" fullWidth onClick={() => navigate(ROUTES.subscriptionPackage())}>{t('subs.see')}</Button>

            <div className="center mt-4">
              <Link to={ROUTES.home()} className="link s-14 black weight-600">
                <u className="weight-700">{t('common.goHome')}</u>
              </Link>
            </div>
          </Container>
        </div>
      </div>
    </Elements.PageBase>
  );
}
